import { type FC } from "react";
import { type Item, SettingsItemTemplate } from "@/pages/settings/__components__/SettingsItemTemplate";
import { pagesPath } from "@/pathpida/generated/$path";
import { contractSettingsNotActiveContractInfoUpdateToastTestId, contractSettingsTestId } from "./const";
import { formatAsiaTokyoDateToString } from "@/modules/utils/date";
import { Toast, useToast } from "@/components/essentials/toast";

interface ContractSettingsProps {
  contractName: string | undefined | null;
  contractedAt: string | undefined | null;
  isActive: boolean | undefined | null;
  id: string;
}
export const ContractSettings: FC<ContractSettingsProps> = ({ contractName, contractedAt, isActive, id }) => {
  const toast = useToast();

  const items: Item[] = [
    {
      icon: "calendarCheck",
      text: `契約日：${formatAsiaTokyoDateToString(contractedAt, "yyyy/MM/dd") ?? "不明"}`,
    },
    {
      icon: "book",
      text: "契約情報の変更",
      ...(isActive
        ? {
            href: pagesPath.settings.contract._contractId(id).$url(),
          }
        : {
            color: "gray.main",
            handleClick: () => {
              toast({
                position: "bottom",
                render: () => (
                  <Toast variant="error" data-testid={contractSettingsNotActiveContractInfoUpdateToastTestId}>
                    停止中の契約の情報は変更することができません。
                  </Toast>
                ),
              });
            },
          }),
    },
  ];

  return (
    <SettingsItemTemplate
      data-testid={`${contractSettingsTestId}-${id}`}
      contractName={contractName}
      items={items}
      contractIsActive={isActive}
    />
  );
};
